<template>
  <div class="row">
    <div class="col-12">
      <card card-body-classes="table-full-width">
        <div slot="header" class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">

          <h4 class="card-title">{{ $t('botClients.pageAll.tableTitle') }}</h4>
          <create-bot-client-btn v-if="$auth.can({fare: 'create'}, 'permissions') && operatorId"
                                 :operator-id="operatorId" :roles="roles"/>
        </div>
        <div>
          <div
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
            <el-select
              class="select-primary mb-3 pagination-select"
              v-model="pagination.perPage"
              placeholder="Per page">
              <el-option
                class="select-primary"
                v-for="item in pagination.perPageOptions"
                :key="item"
                :label="item"
                :value="item"
              >
              </el-option>
            </el-select>

            <div class="row">
              <div class="col">
                <base-input>
                  <el-input
                    type="search"
                    class="mb-3 search-input"
                    prefix-icon="el-icon-search"
                    :placeholder="$t('generic.searchInTablePlaceholder')"
                    v-model="searchQuery"
                    aria-controls="datatables">
                  </el-input>
                </base-input>
              </div>
            </div>
          </div>

          <el-table v-loading="loading" :data="queriedData" :empty-text="$t('generic.noData')">
            <el-table-column type="expand">
              <template slot-scope="props">
                <bot-client-details :details="props.row"/>
              </template>
            </el-table-column>
            <el-table-column
              v-for="column in tableColumns"
              :key="column.label"
              :min-width="column.minWidth"
              :prop="column.prop"
              :label="$t(column.label)"
              :formatter="column.formatter"
            >
            </el-table-column>
            <el-table-column align="right" width="150">
              <div slot-scope="props">
                <router-link
                  :to="{name: 'bot-client', params: {id: props.row.id}}">
                  <i class="tim-icons icon-double-right"></i>
                </router-link>
              </div>
            </el-table-column>
          </el-table>
        </div>
        <div
          slot="footer"
          class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
          <div class="">
            <p class="card-category">
              {{ $t('generic.tablePaginationSummary', {from: from + 1, to: to, total: total}) }}
            </p>
          </div>
          <base-pagination
            class="pagination-no-border"
            v-model="pagination.currentPage"
            :per-page="pagination.perPage"
            :total="total"
          >
          </base-pagination>
        </div>
      </card>
    </div>
  </div>
</template>
<script>
import {Option, Select, Table, TableColumn} from 'element-ui';
import {BaseAlert, BasePagination} from 'src/components';
import Fuse from 'fuse.js';
import {mapActions, mapState} from "vuex";
import BotClientDetails from "src/components/BotClient/BotClientDetails";
import CreateBotClientBtn from "@/pages/BotClients/CreateBotClientBtn";

export default {
  name: 'operatorBotClientsPage',
  props: {
    operatorId: {
      type: String,
      required: true,
    },
  },
  components: {
    CreateBotClientBtn,
    BasePagination,
    BaseAlert,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    BotClientDetails
  },
  computed: {
    ...mapState({
      loading: state => state.operator_bot_clients.loading,
      data: state => state.operator_bot_clients.data,
      roles: state => state.role.roles,
    }),
    /***
     * Returns a page from the searched data or the whole data. Search is performed in the watch section below
     */
    queriedData() {
      let result = this.tableData;
      if (this.searchedData.length > 0) {
        result = this.searchedData;
      }
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.tableData.length;
    }
  },
  data() {
    return {
      pagination: {
        perPage: 50,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0
      },
      searchQuery: '',
      propsToSearch: ['id', 'name'],
      tableColumns: [
        {
          prop: 'id',
          label: 'generic.id',
        },
        {
          prop: 'name',
          label: 'botClients.details.name',
        },
        {
          prop: 'role',
          label: 'botClients.details.role',
        },
        {
          prop: 'type',
          label: 'generic.type',
        },
        {
          prop: 'status',
          label: 'generic.status',
        },
      ],
      tableData: [],
      searchedData: [],
      fuseSearch: null
    };
  },
  methods: {
    ...mapActions(['GetOperatorBotClients', 'DeleteBotClient', 'GetRoles']),
  },
  mounted() {
    this.GetOperatorBotClients({operatorId: this.operatorId}).then(() => {
    })
    this.GetRoles()
  },
  watch: {
    /**
     * Searches through the table data by a given query.
     * NOTE: If you have a lot of data, it's recommended to do the search on the Server Side and only display the results here.
     * @param value of the query
     */
    searchQuery(value) {
      let result = this.tableData;
      if (value !== '') {
        result = this.fuseSearch.search(this.searchQuery);
      }
      this.searchedData = result;
    },
    "data"(data) {
      this.tableData = data
      // Fuse search initialization.
      this.fuseSearch = new Fuse(this.tableData, {
        keys: this.propsToSearch,
        threshold: 0.3
      });
    }
  }
};
</script>
<style>
.pagination-select,
.search-input {
  width: 200px;
}
</style>
